import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export interface CategoryState {

}

const initialState: CategoryState = {
  headerCategories: [],
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {},
});

export default categorySlice.reducer;
